<template>
  <v-card-subtitle :class="customClass" :data-cy="dataCy">
    <v-tooltip location="bottom" :disabled="!tooltipText" :max-width="maxWidth">
      <template v-slot:activator="{ props }">
        <span v-bind="props">
          <span> {{ label }}: </span>
          <span class="value">
            {{ formattedText }}
          </span></span
        >
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-card-subtitle>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'popoverText',
  props: {
    value: String,
    label: String,
    invalidText: String,
    customClass: String,
    tooltipText: String,
    dataCy: String,
    maxWidth: String
  },
  computed: {
    formattedText(): string {
      const noTS = this.invalidText || this.$t('map.popover.notApplicable')
      return this.value || noTS
    }
  }
})
</script>
